const IconEye = (props: any) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M10 4C5.5 4 1.73 6.61 0 10.5 1.73 14.39 5.5 17 10 17s8.27-2.61 10-6.5C18.27 6.61 14.5 4 10 4zm0 10.833c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8.333c-1.84 0-3.33 1.49-3.33 3.33 0 1.84 1.49 3.33 3.33 3.33 1.84 0 3.33-1.49 3.33-3.33 0-1.84-1.49-3.33-3.33-3.33z"
      fill="currentColor"
    />
  </svg>
);

export default IconEye;

